<div mat-dialog-content class="model-content">
  <div class="row p-l-0">
    <div class="col-12 p-l-0 p-b-16">
      <mat-form-field appearance="fill">
        <input #plantNameInput matInput placeholder="Enter Plant Name" type="text" autocomplete="off" [(ngModel)]="data.plantName">
      </mat-form-field>
    </div>
    <div class="row p-l-0">
        <div class="col-12 p-l-0 p-r-3 p-b-16">
            <app-site-selection-dropdown class="notranslate" #buildingListRef [config]="siteSelectionConfig"
            [items]="data?.building ?? []" (selectionChange)="buildingSelected($event)" [value]="selectedSiteId"
            [shortcutKey]="OPEN_SITE_SELECTION_SHORTCUT_KEYS.BUILDING">
            </app-site-selection-dropdown>
        </div>
    </div>
  </div>
  <div class="row p-l-0">
    @if (data.building.length == 0) {
      <div class="warning-text"><i
      class="fas fa-exclamation-triangle warning-icon"></i>No Buildings for this Organization! </div>
    }
    @if (errorText.length > 0) {
      <div class="warning-text"><i
      class="fas fa-exclamation-triangle warning-icon"></i>{{errorText}} </div>
    }
  </div>
</div>
<div mat-dialog-actions>
  <div class="flex-footer  d-flex justify-content-end">
    <div class="col-8 d-flex justify-content-end align-items-center">
      <button (click)="cancel()" class="text-uppercase btn color-primary">CANCEL</button>
      <span class="separatorIcon">|</span>
      <button (click)="save()" class="text-uppercase btn color-primary"
      [ngClass]="{'disabled' : selectedSite.length == 0 || data.plantName.length == 0}">SAVE</button>
    </div>
  </div>
</div>